import React, { Fragment, useState, useEffect, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import FormLabel from "@material-ui/core/FormLabel";
import Divider from "@material-ui/core/Divider";
import Alert from "@material-ui/lab/Alert";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Checkbox from "@material-ui/core/Checkbox";
import {
  CheckBoxOutlineBlank,
  Place,
  NavigateBefore,
  NavigateNext,
  EmojiPeople,
  Business,
  Reorder,
  Repeat,
  CheckBox,
  Pageview,
  LibraryAddCheck,
  LibraryAdd,
  GpsFixed,
} from "@material-ui/icons";
import axios from "axios";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import DateFnsUtils from "@date-io/date-fns";
import format from "date-fns/format";
import deLocale from "date-fns/locale/es";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Slide from "@material-ui/core/Slide";
import StepConnector from "@material-ui/core/StepConnector";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Tooltip from "@material-ui/core/Tooltip";
import Skeleton from "@material-ui/lab/Skeleton";

// SELECT
import LoadCiudades from "components/services/LoadCiudades_conecta2";
import Loadcommunity from "components/services/LoadComunidad_conecta2";
import LoadSector from "components/services/LoadSectores_conecta2";
import LoadGender from "components/services/LoadGender";
import LoadSolutionType from "components/services/LoadSolutionType";

import MapDraggableMarker from "views/Maps/MapDraggableMarker";
import SuccessfulMessage from "views/dialog/SuccessfulMessageForm";
import ResourcesData from "views/dialog/ResourcesData";
import WasteResourcesData from "views/dialog/WasteResourcesData";

import {
  cardStyle,
  ColorlibConnectorCss,
  HtmlTooltipCss,
} from "assets/jss/material-dashboard-react/components/cardStyle";

const useStyles = makeStyles(cardStyle);

const ColorlibConnector = withStyles(ColorlibConnectorCss)(StepConnector);

const HtmlTooltip = withStyles(HtmlTooltipCss)(Tooltip);

export default function Form1() {
  const classes = useStyles();

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  const [loader, setloader] = useState(true);
  const [catSelect, setCatSelect] = useState(false);
  const [catSelectValue, setCatSelectValue] = useState("");
  const [dataCat, setdataCat] = useState("");
  const [mensaje_success, setMensaje_success] = useState("");

  const [catSelectWaste, setCatSelectWaste] = useState(false);
  const [catSelectValueWaste, setCatSelectValueWaste] = useState("");
  const [dataCatWaste, setdataCatWaste] = useState("");

  const [values, setValues] = useState({
    nameContact: "",
    lastNameContact: "",
    documentContact: "",
    email: "",
    descriptionCompany: "",
    nameCompany: "",
    phoneContact: "",
    cityCompany: "",
    cityCompanyData: "",
    latitude: -0.18093079060265435,
    longitude: -78.46778869628906,
    community: "",
    communityData: "",
    dateStartCompany: null,
    addressCompany: "",
    sector: "",
    sectorData: "",
    numberBranchesCompany: "",
    ruc: "0",
    genderContact: "",
    genderContactData: "",
    /* ACTIVIDAD PRIMARIA YO TENGO*/
    deliveryLogistics: [],
    deliveryLogisticsData: [],
    deliveryLogisticsDataViews: [],
    logisticsOutbound: [],
    logisticsOutboundData: [],
    logisticsOutboundDataViews: [],
    operations: [],
    operationsData: [],
    operationsDataViews: [],
    marketing: [],
    marketingData: [],
    marketingDataViews: [],
    services: [],
    servicesData: [],
    servicesDataViews: [],
    /* APOYO Y SOPORTE YO TENGO*/
    infrastructure: [],
    infrastructureData: [],
    infrastructureDataViews: [],
    humanResources: [],
    humanResourcesData: [],
    humanResourcesDataViews: [],
    developmentTechnology: [],
    developmentTechnologyData: [],
    developmentTechnologyDataViews: [],
    buy: [],
    buyData: [],
    buyDataViews: [],
    /* ACTIVIDAD PRIMARIA YO NECESITO*/
    deliveryLogisticsDataN: [],
    deliveryLogisticsDataNViews: [],
    logisticsOutboundDataN: [],
    logisticsOutboundDataNViews: [],
    operationsDataN: [],
    operationsDataNViews: [],
    marketingDataN: [],
    marketingDataNViews: [],
    servicesDataN: [],
    servicesDataNViews: [],
    /* APOYO Y SOPORTE YO TENGO*/
    infrastructureDataN: [],
    infrastructureDataNViews: [],
    humanResourcesDataN: [],
    humanResourcesDataNViews: [],
    developmentTechnologyDataN: [],
    developmentTechnologyDataNViews: [],
    buyDataN: [],
    buyDataNViews: [],
    /*  RESIDUOS ORGANICOS*/
    organicWaste: [],
    organicWasteData: [],
    organicWasteDataViews: [],
    organicWasteDataN: [],
    organicWasteDataNViews: [],
    solutionType: "",
    solutionType_catalog_id: "",
    solutionTypeData: "",
    /* ALERT ERROR */
    errorFieldCity: false,
    errorGenderContact: false,
    errorFieldcommunity: false,
    errorSector: false,
    errorDateStartCompany: false,
    errorNumberBranchesCompany: false,
    errorFieldnameContact: false,
    errorFieldlastNameContact: false,
    errorFielddocumentContact: false,
    errorFieldEmail: false,
    errorFieldphoneContact: false,
    errorFieldnameCompany: false,
    errorFielddescriptionCompany: false,
    errorFieldaddressCompany: false,
    errorFieldRuc: false,
    /*  ALERT RECUROS TENGO*/
    errorDeliveryLogistics: false,
    errorLogisticsOutbound: false,
    errorOperations: false,
    errorMarketing: false,
    errorServices: false,
    errorInfrastructure: false,
    errorHumanResources: false,
    errorDevelopmentTechnology: false,
    errorBuy: false,
    /*  ALERT RECUROS NECESITO*/
    errorDeliveryLogisticsN: false,
    errorLogisticsOutboundN: false,
    errorOperationsN: false,
    errorMarketingN: false,
    errorServicesN: false,
    errorInfrastructureN: false,
    errorHumanResourcesN: false,
    errorDevelopmentTechnologyN: false,
    errorBuyN: false,
    /*  ALERT RECUROS RESIDUALES */
    errorOrganicWaste: false,
    errorOrganicWasteN: false,
    errorSolutionType: false,
  });

  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();
  const [dataLtLgCiudad, setDataLtLgCiudad] = useState({
    lt: -0.18093079060265435,
    lg: -78.46778869628906,
  });
  const [openAlertsuccess, setOpenAlertsuccess] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [mensaje_error, setMensaje_error] = useState("");
  const [openBackdrop, setoOpenBackdrop] = useState(false);

  useEffect(() => {
    const dataCat = {
      catalogs: [
        {
          detailName: "catLogisticaEntrega",
          codeExclusion: "0",
        },
        {
          detailName: "catOperaciones",
          codeExclusion: "0",
        },
        {
          detailName: "catLogisticaSalida",
          codeExclusion: "0",
        },
        {
          detailName: "catMarketing",
          codeExclusion: "0",
        },
        {
          detailName: "catServicios",
          codeExclusion: "0",
        },
        {
          detailName: "catInfraestructura",
          codeExclusion: "0",
        },
        {
          detailName: "catRecursosHumano",
          codeExclusion: "0",
        },
        {
          detailName: "catTecnologia",
          codeExclusion: "0",
        },
        {
          detailName: "catCompra",
          codeExclusion: "0",
        },
        {
          detailName: "catOrganicWaste",
          codeExclusion: "0",
        },
      ],
    };

    axios
      .post(`${urlServices}catalogsDetails/getMultiplesCatalogs`, dataCat, {
        headers: {
          application: keyAplication,
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            setValues({
              ...values,
              /* YO TENGO AND YO NECESITO*/
              deliveryLogistics: response.data.catalogs.catLogisticaEntrega,
              logisticsOutbound: response.data.catalogs.catLogisticaSalida,
              operations: response.data.catalogs.catOperaciones,
              marketing: response.data.catalogs.catMarketing,
              services: response.data.catalogs.catServicios,
              infrastructure: response.data.catalogs.catInfraestructura,
              humanResources: response.data.catalogs.catRecursosHumano,
              developmentTechnology: response.data.catalogs.catTecnologia,
              buy: response.data.catalogs.catCompra,
              /* RECURSOS RESIDUALES */
              organicWaste: response.data.catalogs.catOrganicWaste,
            });
            setloader(false);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }, [urlServices, keyAplication]);

  const handleNext = () => {
    if (activeStep === 0) {
      // STEP 1 PERSONA DE CONTACTO

      if (values.nameContact.length === 0) {
        setValues({
          ...values,
          errorFieldnameContact: true,
        });
        setMensaje_error('El campo "Nombre" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.lastNameContact.length === 0) {
        setValues({
          ...values,
          errorFieldlastNameContact: true,
        });
        setMensaje_error('El campo "Apellidos" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.documentContact.length === 0) {
        setValues({
          ...values,
          errorFielddocumentContact: true,
        });
        setMensaje_error('El campo "Cédula" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.email.length === 0) {
        setValues({
          ...values,
          errorFieldEmail: true,
        });
        setMensaje_error('El campo "Correo Electrónico" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (!values.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
        setValues({
          ...values,
          errorFieldEmail: true,
        });
        setMensaje_error('El campo "Correo Electrónico" no es válido!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.phoneContact.length === 0) {
        setValues({
          ...values,
          errorFieldphoneContact: true,
        });
        setMensaje_error('El campo "Teléfono" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.genderContact.length === 0) {
        setValues({
          ...values,
          errorGenderContact: true,
        });
        setMensaje_error('El campo "Género" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } else if (activeStep === 1) {
      // STEP 2 EMPRESA

      if (values.nameCompany.length === 0) {
        setValues({
          ...values,
          errorFieldnameCompany: true,
        });
        setMensaje_error('El campo "Nombre de la empresa" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.descriptionCompany.length === 0) {
        setValues({
          ...values,
          errorFielddescriptionCompany: true,
        });
        setMensaje_error('El campo "Descripción" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.cityCompany === "") {
        setValues({
          ...values,
          errorFieldCity: true,
        });
        setMensaje_error('Seleccione una opción en "Ciudades"');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.addressCompany.length === 0) {
        setValues({
          ...values,
          errorFieldaddressCompany: true,
        });
        setMensaje_error('El campo "Dirección" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.community === "") {
        setValues({
          ...values,
          errorFieldcommunity: true,
        });
        setMensaje_error('Seleccione una opción en "Comunidad"');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.dateStartCompany === null) {
        setValues({
          ...values,
          errorDateStartCompany: true,
        });
        setMensaje_error(
          'El campo "Fecha de inicio de actividades en Ecuador" es obligatorio!'
        );
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.sector === "") {
        setValues({
          ...values,
          errorSector: true,
        });
        setMensaje_error('Seleccione una opción en "Sectores"');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.numberBranchesCompany.length === 0) {
        setValues({
          ...values,
          errorNumberBranchesCompany: true,
        });
        setMensaje_error('El campo "Número de sedes" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.ruc.length === 0) {
        setValues({
          ...values,
          errorFieldRuc: true,
        });
        setMensaje_error('El campo "RUC" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } else if (activeStep === 2) {
      // STEP 3 EMPRESA YO TENGO
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (activeStep === 3) {
      // STEP 4 EMPRESA YO NECESITO
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (activeStep === 4) {
      // STEP 5 YO TENGO RECURSOS RESIDUALES
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleReset = () => {
    setActiveStep(0);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorNumberBranchesCompany: false,
      errorFieldnameContact: false,
      errorFieldlastNameContact: false,
      errorFielddocumentContact: false,
      errorFieldEmail: false,
      errorFieldphoneContact: false,
      errorFieldnameCompany: false,
      errorFielddescriptionCompany: false,
      errorFieldaddressCompany: false,
      errorFieldRuc: false,
    });
  };

  /*const validateRUC = (e) => {
    // VALIDAMOS EL RUC

    if (e.target.value.length !== 0) {
      const data = {
        ruc: e.target.value,
      };

      axios
        .post(`${urlServices}company/validarruc`, data, {
          headers: {
            application: keyAplication,
          },
        })
        .then(
          (response) => {
            if (response.data !== null) {
              setErrorFieldRuc(true);
              setMensaje_error("RUC ya está registrado.");
              setOpenAlert(true);
              setActiveStep((prevActiveStep) => prevActiveStep - 1);
              setDisableButtomBack(true);
            } else {
              setOpenAlert(false);
              setErrorFieldRuc(false);
              setDisableButtomBack(false);
            }
          },
          (error) => {
            console.log(error);
            setErrorFieldRuc(true);
            setMensaje_error("Error de conexción con el servidor.");
            setOpenAlert(true);
          }
        );
    }
  };*/

  /*const validateMailEmpresa = (e) => {
    // VALIDATE MAIL

    if (e.target.value.length !== 0) {
      const data = {
        mail: e.target.value,
      };

      axios
        .post(`${urlServices}company/validarmail`, data, {
          headers: {
            application: keyAplication,
          },
        })
        .then(
          (response) => {
            if (response.data !== null) {
              setMensaje_error("El correo electrónico ya está registrado.");
              setOpenAlert(true);
              // setActiveStep((prevActiveStep) => prevActiveStep - 1);
              setDisableButtomBack(true);
              setDisableButtomNext(true);
            } else {
              setOpenAlert(false);
              setDisableButtomBack(false);
              setDisableButtomNext(false);
            }
          },
          (error) => {
            console.log(error);
            setMensaje_error("Error de conexción con el servidor.");
            setOpenAlert(true);
          }
        );
    }
  };*/

  const getResponsecommunity = (pro) => {
    if (pro !== null) {
      setValues({
        ...values,
        community: pro.code,
        communityData: pro,
        errorFieldcommunity: false,
      });
    } else {
      setValues({
        ...values,
        community: "",
        communityData: pro,
      });
    }
  };

  const getResponseGender = (pro) => {
    if (pro !== null) {
      setValues({
        ...values,
        genderContact: pro.code,
        genderContactData: pro,
        errorGenderContact: false,
      });
    } else {
      setValues({
        ...values,
        genderContact: "",
        genderContactData: pro,
      });
    }
  };

  const getResponseSolutionType = (pro) => {
    if (pro !== null) {
      setValues({
        ...values,
        solutionType: pro.code,
        solutionType_catalog_id: pro.catalog_id,
        solutionTypeData: pro,
        errorSolutionType: false,
      });
    } else {
      setValues({
        ...values,
        solutionType: "",
        solutionType_catalog_id: "",
        solutionTypeData: pro,
      });
    }
  };

  const getResponseCityCompany = (pro) => {
    if (pro !== null) {
      setValues({
        ...values,
        cityCompany: pro.idCiudad,
        cityCompanyData: pro,
        errorFieldCity: false,
      });
      setDataLtLgCiudad({ lt: pro.latitud, lg: pro.longitud });
    } else {
      setValues({
        ...values,
        cityCompany: "",
        cityCompanyData: pro,
      });
      setDataLtLgCiudad({ lt: -0.18093079060265435, lg: -78.46778869628906 });
    }
  };

  const getResponseSector = (pro) => {
    if (pro !== null) {
      setValues({
        ...values,
        sector: pro.code,
        sectorData: pro,
        errorSector: false,
      });
    } else {
      setValues({ ...values, sector: "", sectorData: pro });
    }
  };

  const handleChangeDateStartCompany = (date) => {
    setValues({
      ...values,
      dateStartCompany: date,
      errorDateStartCompany: false,
    });
  };

  const getResponselt = (latitude) => {
    setValues({ ...values, latitude: latitude });
  };

  const getResponselng = (longitude) => {
    setValues({ ...values, longitude: longitude });
  };

  const handleClose = (event, reason) => {
    setOpenAlert(false);
    setOpenAlertsuccess(false);
  };

  const callbackResourcesData = (data) => {
    if (data.save !== 0) {
      let arr = values[catSelectValue.cat + "Views"];
      arr.push({
        detailName: data.detailName,
        code: data.code,
        cat_id: data.cat_id,
        description: data.description,
        estimatedAmount: data.estimatedAmount,
        transactionType: data.transactionType,
        estimatedAmountName: data.estimatedAmountName,
      });

      setValues({ ...values, [catSelectValue.cat + "Views"]: arr });
    } else {
      catSelectValue.value.map((items, i) => {
        if (items.catalog_id === data.cat_id) {
          if (items.code === data.code) {
            catSelectValue.value.splice(i, 1);
          }
        }
      });

      setValues({ ...values, [catSelectValue.cat]: catSelectValue.value });
    }

    setCatSelect(false);
  };

  const callbackWasteResourcesData = (data) => {
    if (data.save !== 0) {
      let arr = values[catSelectValueWaste.cat + "Views"];

      arr.push({
        detailName: data.detailName,
        code: data.code,
        cat_id: data.cat_id,
        wasteState: data.wasteState,
        wasteStateName: data.wasteStateName,
        estimatedAmount: data.estimatedAmount,
        estimatedAmountName: data.estimatedAmountName,
        weightKg: data.weightKg,
        weightKgName: data.weightKgName,
        transports: data.transports,
        transportsName: data.transportsName,
        transactionType: data.transactionType,
        wasteUsage: data.wasteUsage,
        wasteUsageName: data.wasteUsageName,
      });

      setValues({ ...values, [catSelectValueWaste.cat + "Views"]: arr });
    } else {
      catSelectValueWaste.value.map((items, i) => {
        if (items.catalog_id === data.cat_id) {
          if (items.code === data.code) {
            catSelectValueWaste.value.splice(i, 1);
          }
        }
      });

      setValues({
        ...values,
        [catSelectValueWaste.cat]: catSelectValueWaste.value,
      });
    }

    setCatSelectWaste(false);
  };

  const handleCloseSuccess = (event, reason) => {
    setOpenAlert(false);
    setOpenAlertsuccess(false);
    setActiveStep(0);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /* YO TENGO */

  const changedeliveryLogistics = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.deliveryLogisticsData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.deliveryLogisticsData.length > 0) {
          for (var i1 = 0; i1 < values.deliveryLogisticsData.length; i1++) {
            if (values.deliveryLogisticsData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        deliveryLogisticsData: data,
        errorDeliveryLogistics: false,
      });
      setCatSelectValue({ value: data, cat: "deliveryLogisticsData" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.deliveryLogisticsDataViews);

      setValues({
        ...values,
        deliveryLogisticsData: data,
        deliveryLogisticsDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeLogisticsOutbound = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.logisticsOutboundData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.logisticsOutboundData.length > 0) {
          for (var i1 = 0; i1 < values.logisticsOutboundData.length; i1++) {
            if (values.logisticsOutboundData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        logisticsOutboundData: data,
        errorLogisticsOutbound: false,
      });
      setCatSelectValue({ value: data, cat: "logisticsOutboundData" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.logisticsOutboundDataViews);

      setValues({
        ...values,
        logisticsOutboundData: data,
        logisticsOutboundDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeOperations = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.operationsData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.operationsData.length > 0) {
          for (var i1 = 0; i1 < values.operationsData.length; i1++) {
            if (values.operationsData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        operationsData: data,
        errorOperations: false,
      });
      setCatSelectValue({ value: data, cat: "operationsData" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.operationsDataViews);

      setValues({
        ...values,
        operationsData: data,
        operationsDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeMarketing = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.marketingData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.marketingData.length > 0) {
          for (var i1 = 0; i1 < values.marketingData.length; i1++) {
            if (values.marketingData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        marketingData: data,
        errorMarketing: false,
      });
      setCatSelectValue({ value: data, cat: "marketingData" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.marketingDataViews);

      setValues({
        ...values,
        marketingData: data,
        marketingDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeServices = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.servicesData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.servicesData.length > 0) {
          for (var i1 = 0; i1 < values.servicesData.length; i1++) {
            if (values.servicesData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        servicesData: data,
        errorServices: false,
      });
      setCatSelectValue({ value: data, cat: "servicesData" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.servicesDataViews);

      setValues({
        ...values,
        servicesData: data,
        servicesDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeInfrastructure = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.infrastructureData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.infrastructureData.length > 0) {
          for (var i1 = 0; i1 < values.infrastructureData.length; i1++) {
            if (values.infrastructureData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        infrastructureData: data,
        errorInfrastructure: false,
      });
      setCatSelectValue({ value: data, cat: "infrastructureData" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.infrastructureDataViews);

      setValues({
        ...values,
        infrastructureData: data,
        infrastructureDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeHumanResources = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.humanResourcesData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.humanResourcesData.length > 0) {
          for (var i1 = 0; i1 < values.humanResourcesData.length; i1++) {
            if (values.humanResourcesData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        humanResourcesData: data,
        errorHumanResources: false,
      });
      setCatSelectValue({ value: data, cat: "humanResourcesData" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.humanResourcesDataViews);

      setValues({
        ...values,
        humanResourcesData: data,
        humanResourcesDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeDevelopmentTechnology = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.developmentTechnologyData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.developmentTechnologyData.length > 0) {
          for (var i1 = 0; i1 < values.developmentTechnologyData.length; i1++) {
            if (values.developmentTechnologyData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        developmentTechnologyData: data,
        errorDevelopmentTechnology: false,
      });
      setCatSelectValue({ value: data, cat: "developmentTechnologyData" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.developmentTechnologyDataViews);

      setValues({
        ...values,
        developmentTechnologyData: data,
        developmentTechnologyDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeBuy = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.buyData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.buyData.length > 0) {
          for (var i1 = 0; i1 < values.buyData.length; i1++) {
            if (values.buyData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        buyData: data,
        errorBuy: false,
      });
      setCatSelectValue({ value: data, cat: "buyData" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.buyDataViews);

      setValues({
        ...values,
        buyData: data,
        buyDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  /* YO NECESITO */

  const changedeliveryLogisticsN = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.deliveryLogisticsDataN.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.deliveryLogisticsDataN.length > 0) {
          for (var i1 = 0; i1 < values.deliveryLogisticsDataN.length; i1++) {
            if (values.deliveryLogisticsDataN[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        deliveryLogisticsDataN: data,
        errorDeliveryLogisticsN: false,
      });
      setCatSelectValue({ value: data, cat: "deliveryLogisticsDataN" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.deliveryLogisticsDataNViews);

      setValues({
        ...values,
        deliveryLogisticsDataN: data,
        deliveryLogisticsDataNViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeLogisticsOutboundN = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.logisticsOutboundDataN.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.logisticsOutboundDataN.length > 0) {
          for (var i1 = 0; i1 < values.logisticsOutboundDataN.length; i1++) {
            if (values.logisticsOutboundDataN[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        logisticsOutboundDataN: data,
        errorLogisticsOutboundN: false,
      });
      setCatSelectValue({ value: data, cat: "logisticsOutboundDataN" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.logisticsOutboundDataNViews);

      setValues({
        ...values,
        logisticsOutboundDataN: data,
        logisticsOutboundDataNViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeOperationsN = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.operationsDataN.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.operationsDataN.length > 0) {
          for (var i1 = 0; i1 < values.operationsDataN.length; i1++) {
            if (values.operationsDataN[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        operationsDataN: data,
        errorOperationsN: false,
      });
      setCatSelectValue({ value: data, cat: "operationsDataN" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.operationsDataNViews);

      setValues({
        ...values,
        operationsDataN: data,
        operationsDataNViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeMarketingN = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.marketingDataN.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.marketingDataN.length > 0) {
          for (var i1 = 0; i1 < values.marketingDataN.length; i1++) {
            if (values.marketingDataN[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        marketingDataN: data,
        errorMarketingN: false,
      });
      setCatSelectValue({ value: data, cat: "marketingDataN" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.marketingDataNViews);

      setValues({
        ...values,
        marketingDataN: data,
        marketingDataNViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeServicesN = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.servicesDataN.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.servicesDataN.length > 0) {
          for (var i1 = 0; i1 < values.servicesDataN.length; i1++) {
            if (values.servicesDataN[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        servicesDataN: data,
        errorServicesN: false,
      });
      setCatSelectValue({ value: data, cat: "servicesDataN" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.servicesDataNViews);

      setValues({
        ...values,
        servicesDataN: data,
        servicesDataNViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeInfrastructureN = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.infrastructureDataN.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.infrastructureDataN.length > 0) {
          for (var i1 = 0; i1 < values.infrastructureDataN.length; i1++) {
            if (values.infrastructureDataN[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        infrastructureDataN: data,
        errorInfrastructureN: false,
      });
      setCatSelectValue({ value: data, cat: "infrastructureDataN" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.infrastructureDataNViews);

      setValues({
        ...values,
        infrastructureDataN: data,
        infrastructureDataNViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeHumanResourcesN = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.humanResourcesDataN.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.humanResourcesDataN.length > 0) {
          for (var i1 = 0; i1 < values.humanResourcesDataN.length; i1++) {
            if (values.humanResourcesDataN[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        humanResourcesDataN: data,
        errorHumanResourcesN: false,
      });
      setCatSelectValue({ value: data, cat: "humanResourcesDataN" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.humanResourcesDataNViews);

      setValues({
        ...values,
        humanResourcesDataN: data,
        humanResourcesDataNViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeDevelopmentTechnologyN = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.developmentTechnologyDataN.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.developmentTechnologyDataN.length > 0) {
          for (
            var i1 = 0;
            i1 < values.developmentTechnologyDataN.length;
            i1++
          ) {
            if (values.developmentTechnologyDataN[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        developmentTechnologyDataN: data,
        errorDevelopmentTechnologyN: false,
      });
      setCatSelectValue({ value: data, cat: "developmentTechnologyDataN" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.developmentTechnologyDataNViews);

      setValues({
        ...values,
        developmentTechnologyDataN: data,
        developmentTechnologyDataNViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeBuyN = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.buyDataN.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.buyDataN.length > 0) {
          for (var i1 = 0; i1 < values.buyDataN.length; i1++) {
            if (values.buyDataN[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        buyDataN: data,
        errorBuyN: false,
      });
      setCatSelectValue({ value: data, cat: "buyDataN" });
      setCatSelect(true);
      setdataCat(datos);
    } else {
      output = deleteCatViews(data, values.buyDataNViews);

      setValues({
        ...values,
        buyDataN: data,
        buyDataNViews: data.length !== 0 ? output : data,
      });
    }
  };

  /* RECUROS RESIDUALES */

  const changeOrganicWaste = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.organicWasteData.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.organicWasteData.length > 0) {
          for (var i1 = 0; i1 < values.organicWasteData.length; i1++) {
            if (values.organicWasteData[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        organicWasteData: data,
        errorOrganicWaste: false,
      });
      setCatSelectValueWaste({ value: data, cat: "organicWasteData" });
      setCatSelectWaste(true);
      setdataCatWaste(datos);
    } else {
      output = deleteCatViewsWaste(data, values.organicWasteDataViews);

      setValues({
        ...values,
        organicWasteData: data,
        organicWasteDataViews: data.length !== 0 ? output : data,
      });
    }
  };

  const changeOrganicWasteN = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.organicWasteDataN.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.organicWasteDataN.length > 0) {
          for (var i1 = 0; i1 < values.organicWasteDataN.length; i1++) {
            if (values.organicWasteDataN[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        organicWasteDataN: data,
        errorOrganicWasteN: false,
      });
      setCatSelectValueWaste({ value: data, cat: "organicWasteDataN" });
      setCatSelectWaste(true);
      setdataCatWaste(datos);
    } else {
      output = deleteCatViewsWaste(data, values.organicWasteDataNViews);

      setValues({
        ...values,
        organicWasteDataN: data,
        organicWasteDataNViews: data.length !== 0 ? output : data,
      });
    }
  };

  const deleteCatViews = (data, cat) => {
    for (var i = 0; i < cat.length; i++) {
      var isAGoodUser = false;
      for (var y = 0; y < data.length; y++) {
        if (cat[i].detailName === data[y].detailName) {
          isAGoodUser = true;
          break;
        }
      }
      if (!isAGoodUser) {
        cat.splice(i, 1);
      }
    }

    return cat;
  };

  const deleteCatViewsWaste = (data, cat) => {
    for (var i = 0; i < cat.length; i++) {
      var isAGoodUser = false;
      for (var y = 0; y < data.length; y++) {
        if (cat[i].detailName === data[y].detailName) {
          isAGoodUser = true;
          break;
        }
      }
      if (!isAGoodUser) {
        cat.splice(i, 1);
      }
    }

    return cat;
  };

  const textCatSelect = (items) => {
    let output = [],
      numRows = items.transactionType.length;

    items.transactionType.map((items, i) => {
      output.push(items.detailName);

      if (i < numRows - 1) {
        output.push(", ");
      } else {
        output.push(".");
      }
      return output;
    });

    return (
      <Fragment>
        <p>
          <b>DESCRIPCIÓN:</b> {items.description}
          <br></br> <br></br>
          <b>VALOR ESTIMADO $:</b> {items.estimatedAmountName}
          <br></br> <br></br>
          <b>TIPO DE ACUERDO:</b> {output}
        </p>
      </Fragment>
    );
  };

  const textCatSelectWaste = (items) => {
    let output = [],
      numRows = items.transactionType.length;

    items.transactionType.map((items, i) => {
      output.push(items.detailName);

      if (i < numRows - 1) {
        output.push(", ");
      } else {
        output.push(".");
      }
      return output;
    });

    return (
      <Fragment>
        <p>
          <b>ESTADO:</b> {items.wasteStateName}
          <br></br> <br></br>
          <b>PESO EN KILOS:</b> {items.weightKgName}
          <br></br> <br></br>
          <b>VALOR ESTIMADO $:</b> {items.estimatedAmountName}
          <br></br> <br></br>
          <b>TIPO DE ACUERDO:</b> {output}
          <br></br> <br></br>
          <b>TRANSPORTE:</b> {items.transportsName}
          <br></br> <br></br>
          <b>USO DE RESIDUO:</b> {items.wasteUsageName}
        </p>
      </Fragment>
    );
  };

  const includeHasArrayHave = (views) => {
    let output = [];

    views.map((items, i) => {
      if (items.view.length > 0) {
        items.view.map((items2, i) => {
          output.push({
            have_id: items2.code,
            catalog_id: items2.cat_id,
            another: "0",
            description:
              items2.description === undefined ? null : items2.description,
            estimated_mount_id: items2.estimatedAmount,
            transaction_type: JSON.stringify(items2.transactionType),
            waste_state_id:
              items2.wasteState === undefined ? null : items2.wasteState,
            weight_kg_id:
              items2.weightKg === undefined ? null : items2.weightKg,
            transport_id:
              items2.transports === undefined ? null : items2.transports,
            waste_usage_id:
              items2.wasteUsage === undefined ? null : items2.wasteUsage,
            solution_type_id: null,
          });
        });
      }
    });
    return output;
  };

  const includeHasArrayNeed = (views) => {
    let output = [];

    views.map((items, i) => {
      if (items.view.length > 0) {
        items.view.map((items2, i) => {
          output.push({
            need_id: items2.code,
            catalog_id: items2.cat_id,
            another: "0",
            description:
              items2.description === undefined ? null : items2.description,
            estimated_mount_id: items2.estimatedAmount,
            transaction_type: JSON.stringify(items2.transactionType),
            waste_state_id:
              items2.wasteState === undefined ? null : items2.wasteState,
            weight_kg_id:
              items2.weightKg === undefined ? null : items2.weightKg,
            transport_id:
              items2.transports === undefined ? null : items2.transports,
            waste_usage_id:
              items2.wasteUsage === undefined ? null : items2.wasteUsage,
            solution_type_id: null,
          });
        });
      }
    });
    return output;
  };

  const submitForm = (e) => {
    e.preventDefault();

    setOpenAlertsuccess(false);

    if (
      values.latitude === -0.18093079060265435 &&
      values.longitude === -78.46778869628906
    ) {
      setMensaje_error(
        "Por favor, arrastre el puntero rojo en el mapa para su ubicación!"
      );
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else {
      setoOpenBackdrop(true);

      let arrayHave = [
        {
          view: values.deliveryLogisticsDataViews,
        },
        { view: values.logisticsOutboundDataViews },
        { view: values.operationsDataViews },
        { view: values.marketingDataViews },
        { view: values.servicesDataViews },
        { view: values.buyDataViews },
        { view: values.humanResourcesDataViews },
        { view: values.infrastructureDataViews },
        { view: values.developmentTechnologyDataViews },
        { view: values.organicWasteDataViews },
      ];

      let have = includeHasArrayHave(arrayHave);

      let arrayNeed = [
        {
          view: values.deliveryLogisticsDataNViews,
        },
        { view: values.logisticsOutboundDataNViews },
        { view: values.operationsDataNViews },
        { view: values.marketingDataNViews },
        { view: values.servicesDataNViews },
        { view: values.buyDataNViews },
        { view: values.humanResourcesDataNViews },
        { view: values.infrastructureDataNViews },
        { view: values.developmentTechnologyDataNViews },
        { view: values.organicWasteDataNViews },
      ];

      let need = includeHasArrayNeed(arrayNeed);

      if (values.solutionType !== "") {
        need.push({
          need_id: values.solutionType,
          catalog_id: values.solutionType_catalog_id,
          another: null,
          description: null,
          estimated_mount_id: null,
          transaction_type: null,
          waste_state_id: null,
          weight_kg_id: null,
          transport_id: null,
          waste_usage_id: null,
          solution_type_id: values.solutionType,
        });
      }

      const dataValues = {
        name: values.nameContact,
        last_name: values.lastNameContact,
        document_id: values.documentContact,
        stakeholder_name: values.nameCompany,
        ruc: values.ruc,
        email: values.email.toLowerCase(),
        phone: values.phoneContact,
        gender_id: values.genderContact,
        description: values.descriptionCompany,
        started_at: format(values.dateStartCompany, "yyyy-MM-dd"),
        address: values.addressCompany,
        lat: values.latitude,
        lon: values.longitude,
        city_id: values.cityCompany,
        city_another: "0",
        actor_type_id: null,
        recycler_type_id: null,
        community_id: values.community,
        headquarters: values.numberBranchesCompany,
        sector_id: values.sector,
        solution_id: null,
        solution_another: "0",
        working_men: "0",
        working_women: "0",
        project_name: "0",
        education_center: "0",
        profile_id: 1,
        have: have,
        need: need,
      };

      axios
        .post(`${urlServices}stakeholders`, dataValues, {
          headers: {
            application: keyAplication,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            setValues({
              ...values,
              nameContact: "",
              lastNameContact: "",
              documentContact: "",
              email: "",
              descriptionCompany: "",
              nameCompany: "",
              phoneContact: "",
              cityCompany: "",
              cityCompanyData: "",
              latitude: -0.18093079060265435,
              longitude: -78.46778869628906,
              community: "",
              communityData: "",
              dateStartCompany: null,
              addressCompany: "",
              sector: "",
              sectorData: "",
              numberBranchesCompany: "",
              ruc: "",
              genderContact: "",
              genderContactData: "",
              deliveryLogisticsData: [],
              deliveryLogisticsDataViews: [],
              logisticsOutboundData: [],
              logisticsOutboundDataViews: [],
              operationsData: [],
              operationsDataViews: [],
              marketingData: [],
              marketingDataViews: [],
              servicesData: [],
              servicesDataViews: [],
              infrastructureData: [],
              infrastructureDataViews: [],
              humanResourcesData: [],
              humanResourcesDataViews: [],
              developmentTechnologyData: [],
              developmentTechnologyDataViews: [],
              buyData: [],
              buyDataViews: [],
              deliveryLogisticsDataN: [],
              deliveryLogisticsDataNViews: [],
              logisticsOutboundDataN: [],
              logisticsOutboundDataNViews: [],
              operationsDataN: [],
              operationsDataNViews: [],
              marketingDataN: [],
              marketingDataNViews: [],
              servicesDataN: [],
              servicesDataNViews: [],
              infrastructureDataN: [],
              infrastructureDataNViews: [],
              humanResourcesDataN: [],
              humanResourcesDataNViews: [],
              developmentTechnologyDataN: [],
              developmentTechnologyDataNViews: [],
              buyDataN: [],
              buyDataNViews: [],
              organicWasteData: [],
              organicWasteDataViews: [],
              organicWasteDataN: [],
              organicWasteDataNViews: [],
              solutionType: "",
              solutionTypeData: "",
            });

            setOpenAlertsuccess(true);
            setMensaje_success(
              "Bienvenido(a) a conecta2, se ha enviado un correo electrónico."
            );
            setoOpenBackdrop(false);
          }
        })
        .catch((e) => {
          if (e.response.status === 402) {
            setMensaje_error("Error al registrar los datos");
            setOpenAlert(true);
            setoOpenBackdrop(false);
          } else {
            setMensaje_error("Error al registrar los datos");
            setOpenAlert(true);
            console.log(e);
            setoOpenBackdrop(false);
          }
        });
    }
  };

  const icon = <CheckBoxOutlineBlank fontSize="small" />;
  const checkedIcon = <CheckBox fontSize="small" />;

  return (
    <Fragment>
      <div className={classes.titleCard}>REGISTRO PARA EMPRESAS</div>
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        connector={<ColorlibConnector />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>
              <span style={{ fontSize: 12 }}>{label}</span>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      <div>
        {activeStep === steps.length ? (
          <div>
            <Grid
              container
              spacing={3}
              style={{
                paddingTop: "2%",
                paddingRight: "3%",
                paddingLeft: "3%",
              }}
            >
              <Grid item xs={12} sm={12} style={{ marginTop: "5%" }}>
                <div className={classes.titleCardSub2}>
                  <Place className={classes.iconSubTitle} />
                  UBICACIÓN DE LA EMPRESA
                </div>
              </Grid>

              <Grid item xs={12} md={12} className={classes.mapStyle}>
                <FormLabel component="legend">
                  <div className={classes.fontParagraph}>
                    <GpsFixed /> Habilita la ubicación de tu navegador.
                    <br></br>
                    Por favor, seleccione el puntero rojo y arrastre hasta la
                    ubicación de la empresa.
                  </div>
                </FormLabel>

                <MapDraggableMarker
                  callbacklt={getResponselt}
                  callbacklng={getResponselng}
                  dataltlg={dataLtLgCiudad}
                />
              </Grid>
              <Grid item xs={12} sm={12} style={{ margin: "90px 0" }}>
                <center>
                  <Button
                    startIcon={<NavigateBefore />}
                    onClick={handleReset}
                    className={classes.backButton}
                  >
                    Volver
                  </Button>

                  <Button onClick={submitForm} className={classes.buttonSubmit}>
                    Registrar
                  </Button>
                </center>
              </Grid>
            </Grid>
          </div>
        ) : (
          <div>
            <Typography className={classes.instructions}>
              {getStepContent(
                activeStep,
                values,
                handleChange,
                getResponseCityCompany,
                getResponsecommunity,
                handleChangeDateStartCompany,
                getResponseSector,
                changedeliveryLogistics,
                changeLogisticsOutbound,
                icon,
                checkedIcon,
                classes,
                loader,
                textCatSelect,
                changeOperations,
                changeMarketing,
                changeServices,
                changeInfrastructure,
                changeHumanResources,
                changeDevelopmentTechnology,
                changeBuy,
                getResponseGender,
                changeOperationsN,
                changeMarketingN,
                changeServicesN,
                changeInfrastructureN,
                changeHumanResourcesN,
                changeDevelopmentTechnologyN,
                changeBuyN,
                changedeliveryLogisticsN,
                changeLogisticsOutboundN,
                textCatSelectWaste,
                changeOrganicWaste,
                changeOrganicWasteN,
                getResponseSolutionType
              )}
            </Typography>
            <div>
              <center>
                <div style={{ margin: "10% 0" }}>
                  {activeStep !== 0 ? (
                    <Button
                      onClick={handleBack}
                      className={classes.backButton}
                      startIcon={<NavigateBefore />}
                    >
                      Regresar
                    </Button>
                  ) : (
                    ""
                  )}
                  <Button
                    className={classes.buttonSubmit}
                    endIcon={<NavigateNext />}
                    onClick={handleNext}
                  >
                    {activeStep === steps.length - 1
                      ? "Finalizar"
                      : "Siguiente"}
                  </Button>
                </div>
              </center>
            </div>
          </div>
        )}
      </div>
      <Backdrop
        style={{ zIndex: "9999", color: "#FFFFFF" }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleClose}
      >
        <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
          <Alert
            onClose={handleClose}
            severity="error"
            elevation={6}
            variant="filled"
          >
            {mensaje_error}
          </Alert>
        </Slide>
      </Snackbar>
      {openAlertsuccess ? (
        <SuccessfulMessage
          callbackFalse={handleCloseSuccess}
          callbackTrue={openAlertsuccess}
          mensaje_success={mensaje_success}
        />
      ) : (
        ""
      )}
      {catSelect ? (
        <ResourcesData
          callback={callbackResourcesData}
          open={catSelect}
          data={dataCat}
        />
      ) : (
        ""
      )}

      {catSelectWaste ? (
        <WasteResourcesData
          callback={callbackWasteResourcesData}
          open={catSelectWaste}
          data={dataCatWaste}
        />
      ) : (
        ""
      )}
    </Fragment>
  );
}

function getSteps() {
  return [
    "Contacto",
    "Empresa",
    "Tengo recursos",
    "Necesito recursos",
    "Recursos residuales",
  ];
}

function getStepContent(
  stepIndex,
  values,
  handleChange,
  getResponseCityCompany,
  getResponsecommunity,
  handleChangeDateStartCompany,
  getResponseSector,
  changedeliveryLogistics,
  changeLogisticsOutbound,
  icon,
  checkedIcon,
  classes,
  loader,
  textCatSelect,
  changeOperations,
  changeMarketing,
  changeServices,
  changeInfrastructure,
  changeHumanResources,
  changeDevelopmentTechnology,
  changeBuy,
  getResponseGender,
  changeOperationsN,
  changeMarketingN,
  changeServicesN,
  changeInfrastructureN,
  changeHumanResourcesN,
  changeDevelopmentTechnologyN,
  changeBuyN,
  changedeliveryLogisticsN,
  changeLogisticsOutboundN,
  textCatSelectWaste,
  changeOrganicWaste,
  changeOrganicWasteN,
  getResponseSolutionType
) {
  switch (stepIndex) {
    case 0:
      return step1Form(values, handleChange, classes, getResponseGender);
    case 1:
      return step2Form(
        values,
        handleChange,
        getResponseCityCompany,
        getResponsecommunity,
        handleChangeDateStartCompany,
        getResponseSector,
        classes
      );
    case 2:
      return step3Form(
        values,
        changedeliveryLogistics,
        changeLogisticsOutbound,
        icon,
        checkedIcon,
        classes,
        loader,
        textCatSelect,
        changeOperations,
        changeMarketing,
        changeServices,
        changeInfrastructure,
        changeHumanResources,
        changeDevelopmentTechnology,
        changeBuy
      );
    case 3:
      return step4Form(
        values,
        changedeliveryLogisticsN,
        changeLogisticsOutboundN,
        icon,
        checkedIcon,
        classes,
        loader,
        textCatSelect,
        changeOperationsN,
        changeMarketingN,
        changeServicesN,
        changeInfrastructureN,
        changeHumanResourcesN,
        changeDevelopmentTechnologyN,
        changeBuyN
      );
    case 4:
      return step5Form(
        values,
        icon,
        checkedIcon,
        classes,
        loader,
        textCatSelectWaste,
        changeOrganicWaste,
        changeOrganicWasteN,
        getResponseSolutionType
      );

    default:
      return "Unknown stepIndex";
  }
}

function step1Form(values, handleChange, classes, getResponseGender) {
  return (
    <Fragment>
      <Grid container spacing={2} className={classes.containerStyle}>
        <Grid item xs={12} sm={12} style={{ marginTop: 10 }}>
          <div className={classes.titleCardSub2}>
            <EmojiPeople className={classes.iconSubTitle} />
            PERSONA DE CONTACTO DE LA EMPRESA
          </div>
          <Divider variant="fullWidth" style={{ marginBottom: "4%" }} />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            name="nameContact"
            value={values.nameContact}
            error={values.errorFieldnameContact}
            onChange={handleChange("nameContact")}
            fullWidth
            required
            inputProps={{ maxLength: 100 }}
            autoComplete="off"
            label="Nombre"
            //helperText="Error"
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            name="lastNameContact"
            value={values.lastNameContact}
            error={values.errorFieldlastNameContact}
            onChange={handleChange("lastNameContact")}
            fullWidth
            required
            inputProps={{ maxLength: 100 }}
            autoComplete="off"
            label="Apellidos"
            //helperText="Error"
            margin="dense"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            error={values.errorFielddocumentContact}
            name="documentContact"
            value={values.documentContact}
            onChange={handleChange("documentContact")}
            fullWidth
            required
            inputProps={{ maxLength: 12 }}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}
            autoComplete="off"
            label="Cédula"
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            error={values.errorFieldEmail}
            name="email"
            value={values.email}
            onChange={handleChange("email")}
            /* onInput={(e) => {
               handleValidate(e.target.value);
            }}*/
            fullWidth
            required
            inputProps={{ maxLength: 150 }}
            autoComplete="off"
            label="Correo electrónico"
            margin="dense"
            //   helperText={mensaje_validate}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            error={values.errorFieldphoneContact}
            name="phoneContact"
            value={values.phoneContact}
            onChange={handleChange("phoneContact")}
            fullWidth
            required
            inputProps={{ maxLength: 12 }}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}
            autoComplete="off"
            label="Teléfono"
            margin="dense"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <LoadGender
            callback={getResponseGender}
            value={values.genderContactData}
            error={values.errorGenderContact}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
}

function step2Form(
  values,
  handleChange,
  getResponseCityCompany,
  getResponsecommunity,
  handleChangeDateStartCompany,
  getResponseSector,
  classes
) {
  return (
    <Fragment>
      <Grid container spacing={2} className={classes.containerStyle}>
        <Grid item xs={12} sm={12} style={{ marginTop: 10 }}>
          <div className={classes.titleCardSub2}>
            <Business className={classes.iconSubTitle} />
            DATOS DE LA EMPRESA
          </div>
          <Divider variant="fullWidth" style={{ marginBottom: "4%" }} />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            name="nameCompany"
            value={values.nameCompany}
            error={values.errorFieldnameCompany}
            onChange={handleChange("nameCompany")}
            fullWidth
            required
            inputProps={{ maxLength: 100 }}
            autoComplete="off"
            label="Nombre de la empresa"
            //helperText="Error"
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            name="descriptionCompany"
            value={values.descriptionCompany}
            error={values.errorFielddescriptionCompany}
            onChange={handleChange("descriptionCompany")}
            fullWidth
            required
            inputProps={{ maxLength: 150 }}
            autoComplete="off"
            label="Descripción de la empresa"
            //helperText="Error"
            margin="dense"
            //rows="3"
            multiline
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <LoadCiudades
            callback={getResponseCityCompany}
            value={values.cityCompanyData}
            error={values.errorFieldCity}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            name="addressCompany"
            value={values.addressCompany}
            error={values.errorFieldaddressCompany}
            onChange={handleChange("addressCompany")}
            fullWidth
            required
            inputProps={{ maxLength: 150 }}
            autoComplete="off"
            label="Dirección de la empresa"
            //helperText="Error"
            margin="dense"
            //rows="3"
            multiline
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Loadcommunity
            callback={getResponsecommunity}
            value={values.communityData}
            error={values.errorFieldcommunity}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
            <KeyboardDatePicker
              // disableToolbar
              //  disabled={disabled}
              error={values.errorDateStartCompany}
              variant="inline"
              format="dd/MM/yyyy"
              margin="dense"
              openTo="year"
              autoOk={true}
              id="dateStartCompany"
              autoComplete="off"
              label="Fecha de inicio de actividades en Ecuador"
              value={values.dateStartCompany}
              onChange={handleChangeDateStartCompany}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              style={{ width: "100%" }}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12} sm={6}>
          <LoadSector
            callback={getResponseSector}
            value={values.sectorData}
            error={values.errorSector}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            name="numberBranchesCompany"
            value={values.numberBranchesCompany}
            onChange={handleChange("numberBranchesCompany")}
            fullWidth
            required
            inputProps={{ maxLength: 2 }}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}
            autoComplete="off"
            label="Número de sedes en Ecuador"
            //helperText="Error"
            margin="dense"
            error={values.errorNumberBranchesCompany}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            name="ruc"
            value={values.ruc}
            error={values.errorFieldRuc}
            onChange={handleChange("ruc")}
            fullWidth
            required
            inputProps={{ maxLength: 14 }}
            // onBlur={validateRUC}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}
            autoComplete="off"
            label="RUC de la empresa"
            //helperText="Error"
            margin="dense"
          />
        </Grid>
      </Grid>
    </Fragment>
  );
}

function step3Form(
  values,
  changedeliveryLogistics,
  changeLogisticsOutbound,
  icon,
  checkedIcon,
  classes,
  loader,
  textCatSelect,
  changeOperations,
  changeMarketing,
  changeServices,
  changeInfrastructure,
  changeHumanResources,
  changeDevelopmentTechnology,
  changeBuy
) {
  return (
    <Fragment>
      <Grid container spacing={2} className={classes.containerStyle}>
        <Grid item xs={12} sm={12} style={{ marginTop: 10 }}>
          <div className={classes.titleCardSub2}>
            OPTIMIZACIÓN DE RECURSOS PARA MEJORAR LA CADENA DE VALOR <br></br>
            <span style={{fontSize:18}}>(YO TENGO)</span>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} style={{ marginTop: 10 }}>
          <div className={classes.titleCardSub2}>
            <Reorder className={classes.iconSubTitle} />
            ACTIVIDADES PRIMARIAS
          </div>
          <Divider variant="fullWidth" style={{ marginBottom: "4%" }} />
        </Grid>

        <Grid item xs={12} sm={6}>
          {loader ? (
            <Fragment>
              <FormLabel component="legend">Logística de entrega</FormLabel>
              <center>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="deliveryLogistics"
                options={values.deliveryLogistics}
                value={values.deliveryLogisticsData}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changedeliveryLogistics}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorDeliveryLogistics}
                    name="deliveryLogistics"
                    //  required
                    label="Logística de entrega"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.deliveryLogisticsDataViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelect(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>
                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          {loader ? (
            <Fragment>
              <FormLabel component="legend">Logística de salida</FormLabel>
              <center>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="logisticsOutbound"
                options={values.logisticsOutbound}
                value={values.logisticsOutboundData}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changeLogisticsOutbound}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorLogisticsOutbound}
                    name="logisticsOutbound"
                    //  required
                    label="Logística de salida"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.logisticsOutboundDataViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelect(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>

                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          {loader ? (
            <Fragment>
              <FormLabel component="legend">Operaciones</FormLabel>
              <center>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="operations"
                options={values.operations}
                value={values.operationsData}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changeOperations}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorOperations}
                    name="operations"
                    //  required
                    label="Operaciones"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.operationsDataViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelect(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>

                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          {loader ? (
            <Fragment>
              <center>
                <FormLabel component="legend">Marketing</FormLabel>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="marketing"
                options={values.marketing}
                value={values.marketingData}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changeMarketing}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorMarketings}
                    name="marketing"
                    //  required
                    label="Marketing y ventas"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.marketingDataViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelect(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>

                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          {loader ? (
            <Fragment>
              <FormLabel component="legend">Servicios</FormLabel>
              <center>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="services"
                options={values.services}
                value={values.servicesData}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changeServices}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorServices}
                    name="services"
                    //  required
                    label="Servicios"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.servicesDataViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelect(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>

                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>

        {/* SCTION 2*/}

        <Grid item xs={12} sm={12} style={{ marginTop: 10 }}>
          <div className={classes.titleCardSub2}>
            <Repeat className={classes.iconSubTitle} />
            ACTIVIDADES DE APOYO Y SOPORTE
          </div>
          <Divider variant="fullWidth" style={{ marginBottom: "4%" }} />
        </Grid>
        <Grid item xs={12} sm={6}>
          {loader ? (
            <Fragment>
              <FormLabel component="legend">Infraestructura</FormLabel>
              <center>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="infrastructure"
                options={values.infrastructure}
                value={values.infrastructureData}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changeInfrastructure}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorInfrastructure}
                    name="infrastructure"
                    //  required
                    label="Infraestructura"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.infrastructureDataViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelect(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>

                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          {loader ? (
            <Fragment>
              <FormLabel component="legend">Recursos humanos</FormLabel>
              <center>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="humanResources"
                options={values.humanResources}
                value={values.humanResourcesData}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changeHumanResources}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorHumanResources}
                    name="humanResources"
                    //  required
                    label="Recursos humanos"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.humanResourcesDataViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelect(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>

                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          {loader ? (
            <Fragment>
              <FormLabel component="legend">Desarrollo de tecnología</FormLabel>
              <center>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="developmentTechnology"
                options={values.developmentTechnology}
                value={values.developmentTechnologyData}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changeDevelopmentTechnology}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorDevelopmentTechnology}
                    name="developmentTechnology"
                    //  required
                    label="Desarrollo de tecnología"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.developmentTechnologyDataViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelect(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>

                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          {loader ? (
            <Fragment>
              <FormLabel component="legend">Compras</FormLabel>
              <center>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="buy"
                options={values.buy}
                value={values.buyData}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changeBuy}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorBuy}
                    name="buy"
                    //  required
                    label="Compras"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.buyDataViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelect(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>

                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>
      </Grid>
    </Fragment>
  );
}

function step4Form(
  values,
  changedeliveryLogisticsN,
  changeLogisticsOutboundN,
  icon,
  checkedIcon,
  classes,
  loader,
  textCatSelect,
  changeOperationsN,
  changeMarketingN,
  changeServicesN,
  changeInfrastructureN,
  changeHumanResourcesN,
  changeDevelopmentTechnologyN,
  changeBuyN
) {
  return (
    <Fragment>
      <Grid container spacing={2} className={classes.containerStyle}>
        <Grid item xs={12} sm={12} style={{ marginTop: 10 }}>
          <div className={classes.titleCardSub2}>
            OPTIMIZACIÓN DE RECURSOS PARA MEJORAR LA CADENA DE VALOR<br></br>
            <span style={{fontSize:18}}>(YO NECESITO)</span>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} style={{ marginTop: 10 }}>
          <div className={classes.titleCardSub2}>
            <Reorder className={classes.iconSubTitle} />
            ACTIVIDADES PRIMARIAS{" "}
          </div>
          <Divider variant="fullWidth" style={{ marginBottom: "4%" }} />
        </Grid>

        <Grid item xs={12} sm={6}>
          {loader ? (
            <Fragment>
              <FormLabel component="legend">Logística de entrega</FormLabel>
              <center>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="deliveryLogisticsN"
                options={values.deliveryLogistics}
                value={values.deliveryLogisticsDataN}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changedeliveryLogisticsN}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorDeliveryLogisticsN}
                    name="deliveryLogisticsN"
                    //  required
                    label="Logística de entrega"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.deliveryLogisticsDataNViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelect(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>
                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          {loader ? (
            <Fragment>
              <FormLabel component="legend">Logística de salida</FormLabel>
              <center>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="logisticsOutboundN"
                options={values.logisticsOutbound}
                value={values.logisticsOutboundDataN}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changeLogisticsOutboundN}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorLogisticsOutboundN}
                    name="logisticsOutboundN"
                    //  required
                    label="Logística de salida"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.logisticsOutboundDataNViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelect(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>

                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          {loader ? (
            <Fragment>
              <FormLabel component="legend">Operaciones</FormLabel>
              <center>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="operationsN"
                options={values.operations}
                value={values.operationsDataN}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changeOperationsN}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorOperationsN}
                    name="operationsN"
                    //  required
                    label="Operaciones"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.operationsDataNViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelect(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>

                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          {loader ? (
            <Fragment>
              <center>
                <FormLabel component="legend">Marketing</FormLabel>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="marketingN"
                options={values.marketing}
                value={values.marketingDataN}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changeMarketingN}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorMarketingsN}
                    name="marketingN"
                    //  required
                    label="Marketing y ventas"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.marketingDataNViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelect(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>

                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          {loader ? (
            <Fragment>
              <FormLabel component="legend">Servicios</FormLabel>
              <center>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="servicesN"
                options={values.services}
                value={values.servicesDataN}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changeServicesN}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorServicesN}
                    name="servicesN"
                    //  required
                    label="Servicios"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.servicesDataNViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelect(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>

                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>

        {/* SCTION 2*/}

        <Grid item xs={12} sm={12} style={{ marginTop: 10 }}>
          <div className={classes.titleCardSub2}>
            <Repeat className={classes.iconSubTitle} />
            ACTIVIDADES DE APOYO Y SOPORTE
          </div>
          <Divider variant="fullWidth" style={{ marginBottom: "4%" }} />
        </Grid>
        <Grid item xs={12} sm={6}>
          {loader ? (
            <Fragment>
              <FormLabel component="legend">Infraestructura</FormLabel>
              <center>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="infrastructureN"
                options={values.infrastructure}
                value={values.infrastructureDataN}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changeInfrastructureN}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorInfrastructureN}
                    name="infrastructureN"
                    //  required
                    label="Infraestructura"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.infrastructureDataNViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelect(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>

                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          {loader ? (
            <Fragment>
              <FormLabel component="legend">Recursos humanos</FormLabel>
              <center>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="humanResourcesN"
                options={values.humanResources}
                value={values.humanResourcesDataN}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changeHumanResourcesN}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorHumanResourcesN}
                    name="humanResourcesN"
                    //  required
                    label="Recursos humanos"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.humanResourcesDataNViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelect(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>

                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          {loader ? (
            <Fragment>
              <FormLabel component="legend">Desarrollo de tecnología</FormLabel>
              <center>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="developmentTechnologyN"
                options={values.developmentTechnology}
                value={values.developmentTechnologyDataN}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changeDevelopmentTechnologyN}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorDevelopmentTechnologyN}
                    name="developmentTechnologyN"
                    //  required
                    label="Desarrollo de tecnología"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.developmentTechnologyDataNViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelect(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>

                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          {loader ? (
            <Fragment>
              <FormLabel component="legend">Compras</FormLabel>
              <center>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="buyN"
                options={values.buy}
                value={values.buyDataN}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changeBuyN}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorBuyN}
                    name="buyN"
                    //  required
                    label="Compras"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.buyDataNViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelect(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>

                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>
      </Grid>
    </Fragment>
  );
}

function step5Form(
  values,
  icon,
  checkedIcon,
  classes,
  loader,
  textCatSelectWaste,
  changeOrganicWaste,
  changeOrganicWasteN,
  getResponseSolutionType
) {
  return (
    <Fragment>
      <Grid container spacing={2} className={classes.containerStyle}>
        <Grid item xs={12} sm={12} style={{ marginTop: 10, marginBottom: 20 }}>
          <div className={classes.titleCardSub2}>RECURSOS RESIDUALES</div>
        </Grid>
        <Grid item xs={12} sm={6}>
          <div className={classes.titleCardSub2}>
            <LibraryAddCheck className={classes.iconSubTitle} />
            YO TENGO
          </div>
          {loader ? (
            <Fragment>
              <FormLabel component="legend">Desechos orgánicos</FormLabel>
              <center>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="organicWaste"
                options={values.organicWaste}
                value={values.organicWasteData}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changeOrganicWaste}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorOrganicWaste}
                    name="organicWaste"
                    //  required
                    label="Desechos orgánicos"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.organicWasteDataViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelectWaste(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>

                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <div className={classes.titleCardSub2}>
            <LibraryAdd className={classes.iconSubTitle} />
            YO NECESITO
          </div>
          {loader ? (
            <Fragment>
              <FormLabel component="legend">Desechos orgánicos</FormLabel>
              <center>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="organicWasteN"
                options={values.organicWaste}
                value={values.organicWasteDataN}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changeOrganicWasteN}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorOrganicWasteN}
                    name="organicWasteN"
                    //  required
                    label="Desechos orgánicos"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.organicWasteDataNViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelectWaste(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>

                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>
        <Grid item xs={12} sm={12} style={{ marginTop: 20 }}>
          <div className={classes.titleCardSub2}>
            <Repeat className={classes.iconSubTitle} />
            BUSCAR PROYECTOS SOSTENIBLES PARA TU EMPRESA U ORGANIZACIÓN
          </div>
          <Divider variant="fullWidth" style={{ marginBottom: "4%" }} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LoadSolutionType
            callback={getResponseSolutionType}
            value={values.solutionTypeData}
            error={values.errorSolutionType}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
}
